export enum PartyAttributeType {
    Firstname = "firstname",
    Lastname = "lastname",
    Phone = "phone",
    Email = "email",
    Civility = "civility",
    Structure = "structure",
    Service = "service",
    Address = "address",
}
